import { FormGroup, Grid } from "@mui/material";
import RhfCheckGroup from "../../../libs/rhf-mui/RhfCheckGroup";
import RhfRadioGroup from "../../../libs/rhf-mui/RhfRadioGroup";
import Label from "../../../libs/rhf-mui/ui/Label";
import { UniOption } from "../../dao/UniOption";
import { UniQuestion } from "../../dao/UniQuestion";
import { Lang, SpwkUtil } from "../../dao/SpwkUtil";
import UcOption from "./UcOption";
import RhfErrorText from "../../../libs/rhf-mui/RhfErrorText";
import { Member } from "../../dao/Member";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { useTranslation } from "react-i18next";

type Props = {
  question: UniQuestion;
  member: Member | null | undefined;
  LangA: Lang;
  LangB: Lang;
};

const UcQuestion = ({ question, member, LangA, LangB, ...props }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      sx={{ pt: 0.5, pb: 1.5 }}
      direction={question.sm_inline ? "row" : "column"}
    >
      {render_Title()}
      <Grid item xs={12} sm sx={{}}>
        {render_OptionsArea()}
      </Grid>

      {render_Error()}
    </Grid>
  );

  function render_Error() {
    let rhf_name = question.get_Question_RhfName();
    return <RhfErrorText name={rhf_name} />;
  }

  function render_Title() {
    let title_props: any = { ...{ xs: 12, sm: "auto" } };

    let title_a = t(question.question_title);
    let title_b = question.getTitleLangB(LangB);

    return (
      <Grid
        item
        container
        {...title_props}
        sx={{ py: "6px" }}
        direction="column"
      >
        {title_a != null && title_a === "" ? undefined : (
          <Grid item>
            <Label color="#005A9E" bold>
              {" "}
              {title_a}{" "}
            </Label>
          </Grid>
        )}

        <Grid item>
          {title_b != null && title_b !== "" ? (
            <Label variant="caption" color="text.disabled" sx={{ pl: "4px" }}>
              {" "}
              {title_b}{" "}
            </Label>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    );
  }

  function render_OptionsArea() {
    const kind = question.kind;
    if (member === null || member === undefined) {
      throw new_ErrorAlert("540881" + "不知名的錯誤");
    }
    if (kind === SpwkUtil.KIND_多選) {
      return render_多選題(question, member, LangA, LangB);
    } else if (kind === SpwkUtil.KIND_單選) {
      console.log("got something");
      return render_單選題(question, member, LangA, LangB);
    } else if (kind === SpwkUtil.KIND_非選) {
      return render_非選題(question, member, LangA, LangB);
    } else {
      return render_多選題(question, member, LangA, LangB);
    }
  }
};

function render_Items(
  question: UniQuestion,
  member: Member,
  LangA: Lang,
  LangB: Lang
) {
  const options: UniOption[] = question.Options ?? [];
  return options.map((option) => {
    return (
      <UcOption
        key={option.guid}
        option={option}
        member={member}
        LangA={LangA}
        LangB={LangB}
      />
    );
  });
}

function render_多選題(
  question: UniQuestion,
  member: Member,
  LangA: Lang,
  LangB: Lang
) {
  const rhf_name = question.question_code;

  return (
    <RhfCheckGroup row name={rhf_name}>
      {render_Items(question, member, LangA, LangB)}
    </RhfCheckGroup>
  );
}

function render_單選題(
  question: UniQuestion,
  member: Member,
  LangA: Lang,
  LangB: Lang
) {
  const rhf_name = question.get_Question_RhfName();

  return (
    <RhfRadioGroup row name={rhf_name}>
      {render_Items(question, member, LangA, LangB)}
    </RhfRadioGroup>
  );
}

function render_非選題(
  question: UniQuestion,
  member: Member,
  LangA: Lang,
  LangB: Lang
) {
  return (
    <FormGroup row>{render_Items(question, member, LangA, LangB)}</FormGroup>
  );
}

export default UcQuestion;
